import React from "react";
import "./Home.css";

const divisionsData = [
  {
    title: "CONTRACTS",
    description:
      "Our contracts division provides full-service electrical contracting for a wide variety of installations for the Baltimore area.",
  },
  {
    title: "SERVICE",
    description:
      "Our service division prides itself on providing quality craftsmanship at a competitive price in order to meet the needs of our customers.",
  },
  {
    title: "UTILITY",
    description:
      "Our utility division is equipped with the finest crew members, along with an impressive fleet of equipment to provide exceptional underground & aerial services.",
  },
];

const DivisionCards = () => {
  return (
    <div className="container">
      <div className="row">
        {divisionsData.map((division, index) => (
          <div key={index} className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{division.title}</h5>
                <p className="card-text">{division.description}</p>
                <a href="/read-more" className="btn btn-primary">
                  Read More
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DivisionCards;
